import React from 'react';

interface Props {
  depth?: number;
}

export const GROUP_ROW_IDENT = 40;

export const RowIndent: React.FC<Props> = (props) => {
  if (typeof props.depth !== 'number') {
    return null;
  }

  const depth = props.depth;

  return (
    <div
      style={{
        width: `${depth * GROUP_ROW_IDENT}px`,
      }}
    />
  );
};
